import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function TopBanner() {
  const [time, setTime] = useState({
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prev => {
        let {
          minutes,
          seconds
        } = prev;
        seconds++;
        if (seconds >= 60) {
          seconds = 0;
          minutes++;
        }
        return {
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className="bg-[#2d3340] py-3 px-4 text-center sticky top-0 z-50 border-b-2 border-palomitas-gold" data-id="element-296">
      <p className="text-white font-bold text-sm md:text-base flex items-center justify-center gap-2" data-id="element-297">
        <span data-id="element-298">⏱</span>
        <motion.span animate={{
        scale: [1, 1.2, 1]
      }} transition={{
        duration: 0.6,
        repeat: Infinity
      }} className="inline-block" data-id="element-299">
          🔥
        </motion.span>
        <span data-id="element-300">ÚLTIMOS 3 CUPOS CON BONOS Y PRECIO CONGELADO:</span>
        <span className="text-palomitas-gold font-bold ml-1" data-id="element-301">
          {String(time.minutes).padStart(2, '0')}:
          {String(time.seconds).padStart(2, '0')}
        </span>
      </p>
    </div>;
}